import {
  API_VERSION,
  RESOURCE_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_QUALIFICATION = `${RESOURCE_SERVICE}/qualifications`;

export const qualifications = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_QUALIFICATION,
      method: "get",
      header: { [X_API_VERSION]: API_VERSION, "MV-UserId": "test" },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },

  getById: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}`,
      header: { [X_API_VERSION]: API_VERSION },
      method: "get",
    });
    return apiRequest(options);
  },

  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  activate: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}/activate`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  deactivate: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}/deactivate`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  relationships: async ({ id, resourceId, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}/resources/${resourceId}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  deleteRelationships: async ({ id, resourceId, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_QUALIFICATION}/${id}/resources/${resourceId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
